import { makeStyles, withStyles } from '@mui/styles';
import {Tab, Tabs} from "@mui/material";

export const AntTabs = withStyles(theme => ({
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
}))(Tabs);

export const AntTab = withStyles(theme => ({
  root: {
    minWidth: 0,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
    textAlign: 'center',
    padding: '24px 15px',
    letterSpacing: '1.25px',
    textTransform: 'uppercase',
    color: '#363636',
    maxWidth: 500,
    '&:hover': {
      background: theme.palette.grey.greyLight,
      opacity: 1,
    },
    '&$selected': {
      color: theme.palette.primary.main,
    },
    '&:focus': {
      color: theme.palette.primary.main,
    },
  },
  textColorInherit: {
    opacity: 1,
  },
  selected: {},
}))(props => <Tab disableRipple {...props} />);

export const useStyles = makeStyles((theme) => ({
  switchWrapper: {
    marginLeft: '-10px',
    '& .MuiSwitch-colorSecondary.Mui-checked': {
      color: 'rgb(0, 233, 198)',
    },

    '& .Mui-checked + .MuiSwitch-track': {
      backgroundColor: ' rgb(1, 205, 203)',
    },

    '& .switchBase': {
      color: '#F1F1F1',
      '& + $track': {
        backgroundColor: theme.palette.grey.greyDark,
        borderColor: theme.palette.grey.greyDark,
        opacity: 1,
      },
      '&$checked': {
        color: theme.palette.primary.main,
        '& + $track': {
          backgroundColor: theme.palette.primary.primary100,
          borderColor: theme.palette.primary.primary100,
          opacity: 1,
        },
        '&:hover': {
          backgroundColor: theme.palette.grey.greyLight,
        },
      },
    },
    track: {},
    checked: {},
  },
  text: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 18,
    lineHeight: '24px',
    marginRight: '20px',
    whiteSpace: 'nowrap',
  },
  pickerWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  dataPicker: {
    margin: '5px',
    border: 0,
    padding: '9.5px 0',
    fontSize: '14px',
    lineHeight: '21px',
    letterSpacing: '0.25px',
    color: theme.palette.dataPiker.colorInputDefault,
    backgroundColor: theme.palette.dataPiker.bgInputDefault,
    textAlign: 'center',
    borderRadius: 4,
    maxWidth: 150,
    '&:hover': {
      outlineColor: theme.palette.dataPiker.colorInputFocus,
      outline: '1px solid',
    },
    '&:focus': {
      color: theme.palette.dataPiker.colorInputFocus,
      outlineColor: theme.palette.primary.main,
      outline: '2px solid',
    },
    '&:disabled:hover': {
      outline: 'none',
      cursor: 'not-allowed',
    },
  },
  poper: {
    '& .react-datepicker__header': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    '& .react-datepicker__day-name, .react-datepicker__current-month,': {
      color: theme.palette.primary.contrastText,
    },
    '&  .react-datepicker-time__header': {
      color: theme.palette.primary.contrastText,
      minHeight: '46px',
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item':
      {
        height: '25px',
        padding: '5px 10px',
      },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list':
      {
        padding: '8px 0',
      },
    '& .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range':
      {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 15,
      },

    '& .react-datepicker__day:hover': {
      borderRadius: 15,
    },
    '& .react-datepicker__day--keyboard-selected': {
      borderRadius: 15,
    },
    '& .react-datepicker__day--keyboard-selected:hover:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover':
      {
        backgroundColor: theme.palette.primary.main,
      },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected':
      {
        backgroundColor: theme.palette.primary.main,
      },
    '& .react-datepicker__day--today, .react-datepicker__month-text--today, .react-datepicker__quarter-text--today, .react-datepicker__year-text--today':
      {
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 15,
        color: theme.palette.primary.main,
      },
  },

  inputWrapper: {
    maxWidth: 550,
  },
  input: {
    width: '100%',
    marginBottom: 30,
  },
  buttonBox: {
    marginBottom: 100,
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },

  title: {
    marginBottom: 30,
  },

  checkedBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 20,
  },
  switch: {
    margin: '0 50px',
  },
  radioWrap: {
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: 'rgb(0, 233, 198)',
    },
  },
  bar: {
    background: theme.palette.navTab.bg,
    borderTopWidth: 0,
    borderBottomWidth: '1px',
    borderColor: theme.palette.navTab.border,
    borderBlockStyle: 'solid',
  },
  validation: {
    marginLeft: 30,
  },
  link: {
    textDecoration: 'none',
    color: '#363636',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
    textAlign: 'center',
    letterSpacing: '1.25px',
    textTransform: 'uppercase',
  },
  linkActive: {
    color: theme.palette.primary.main,
  },
  itemTab: {
    flex: '100%',
  },
  wrapper: {
    display: 'none',
    padding: '0 5px 0 14px',
    borderBottom: '2px solid rgba(0, 0, 0, 0.12)',
  },
  icon: {
    color: theme.palette.grey.greyInactive,
    fontSize: '24px',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  servicesContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'end',
    marginBottom: 25,
  }
}));
